import isUndefined from 'lodash.isundefined';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

// components
import { BodyMedium } from '@styled';

// functionality
import { getCurrencySymbol } from '@general/helpers/currency.helpers';
import colors from '@general/colors';
import eventPropTypes from '@react/propTypes/eventPropTypes';

const NonMemberPriceTextStyled = styled(BodyMedium)`
    color: ${colors.mediumGray};
    margin-right: 8px;
    text-decoration: line-through;
`;

const EventPrices = ({ eventFromAPI }) => {
    const [memberFee, setMemberFee] = useState();
    const [nonMemberFee, setNonMemberFee] = useState();
    const [currencySymbol, setCurrencySymbol] = useState('$');

    useEffect(() => {
        if (!eventFromAPI) {
            return;
        }

        const fullProgram = eventFromAPI.functions.find(f => f.code === 'FP');
        setMemberFee(fullProgram.fees.find(f => f.registrant_class === 'M') || null);
        setNonMemberFee(fullProgram.fees.find(f => f.registrant_class === 'NM') || null);
        setCurrencySymbol(getCurrencySymbol(eventFromAPI.locale));
    }, [eventFromAPI]);

    if (isUndefined(memberFee) || isUndefined(nonMemberFee)) {
        return null;
    }

    return (
        <div className="flex">
            {nonMemberFee && nonMemberFee.price !== memberFee.price && (
                <NonMemberPriceTextStyled>
                    {currencySymbol}
                    {nonMemberFee.price.toLocaleString('en')}
                </NonMemberPriceTextStyled>
            )}

            {memberFee && (
                <BodyMedium>
                    {currencySymbol}
                    {memberFee.price.toLocaleString('en')}
                </BodyMedium>
            )}
        </div>
    );
};

EventPrices.propTypes = {
    eventFromAPI: eventPropTypes,
};

export default EventPrices;
